var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAnnouncementRedDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#364054"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.168 4.583a3.75 3.75 0 1 1-7.501 0 3.75 3.75 0 0 1 7.501 0z",
    fill: "#FA4F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.138 18.427H9.834l1.42-2.279a.833.833 0 0 0 .125-.44v-2.96a3.585 3.585 0 0 1 3.582-3.581 3.585 3.585 0 0 1 3.58 3.58v2.96c0 .16.047.317.133.452l1.464 2.268zM8.333 20.095h13.334a.834.834 0 0 0 .7-1.285l-2.159-3.347v-2.714A5.253 5.253 0 0 0 14.962 7.5a5.254 5.254 0 0 0-5.248 5.248v2.721L7.626 18.82a.832.832 0 0 0 .707 1.274zm3.611 0A3.06 3.06 0 0 0 15 23.15a3.06 3.06 0 0 0 3.056-3.056h-1.667A1.39 1.39 0 0 1 15 21.484a1.39 1.39 0 0 1-1.389-1.39h-1.667z",
    fill: "#A4BED0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnnouncementRedDark);
export default __webpack_public_path__ + "static/media/ic-announcement-red-dark.22c4e3e3a87666845005451d6edac7d2.svg";
export { ForwardRef as ReactComponent };